import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';

export interface TaskDurationInputProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

export const TaskDurationInput: React.FC<TaskDurationInputProps> = ({
  value,
  onChange,
  label = 'Duration',
}) => {
  const [hours, minutes] = (value || '00:00').split(':').map(Number);

  const handleHoursChange = (h: number) => {
    const clamped = Math.max(0, Math.min(99, h || 0));
    onChange(`${String(clamped).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`);
  };

  const handleMinutesChange = (m: number) => {
    const clamped = Math.max(0, Math.min(59, m || 0));
    onChange(`${String(hours).padStart(2, '0')}:${String(clamped).padStart(2, '0')}`);
  };

  return (
    <Box>
      <Typography sx={{ fontSize: '11px', fontWeight: 600, color: 'text.secondary', mb: 0.5 }}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <TextField
          size="small" type="number" placeholder="HH"
          value={hours || ''}
          onChange={(e) => handleHoursChange(parseInt(e.target.value, 10))}
          slotProps={{ htmlInput: { min: 0, max: 99 } }}
          sx={{ width: 80, '& .MuiOutlinedInput-root': { fontSize: '12px' } }}
        />
        <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>:</Typography>
        <TextField
          size="small" type="number" placeholder="MM"
          value={minutes || ''}
          onChange={(e) => handleMinutesChange(parseInt(e.target.value, 10))}
          slotProps={{ htmlInput: { min: 0, max: 59 } }}
          sx={{ width: 80, '& .MuiOutlinedInput-root': { fontSize: '12px' } }}
        />
      </Box>
    </Box>
  );
};
